module.exports = __webpack_public_path__ + "img/tb-10.021052be.png";